import React from 'react';
import PlayerObject from 'game/scenes/test/PlayerObject';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function PlayerObjectPage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [PlayerObject],
            physics: {
              arcade: {
                gravity: { y: 0 },
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
